
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Edit } from 'lucide-react';
import EditBookForm from './EditBookForm';
import { Book } from '@/types';

interface EditBookDialogProps {
  book: Book;
  trigger?: React.ReactNode;
}

const EditBookDialog: React.FC<EditBookDialogProps> = ({ book, trigger }) => {
  const [open, setOpen] = React.useState(false);

  const handleSuccess = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="ghost" size="sm">
            <Edit className="h-4 w-4" />
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Edit Book</DialogTitle>
        </DialogHeader>
        <EditBookForm book={book} onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
};

export default EditBookDialog;
